import { useState } from 'react';
import { CONTACT_CONFIG } from '../config/contact';
import { PricingCard } from '../components/PricingCard';
import { STANDARD_PLANS, MULTI_SCREEN_PLANS, LIFETIME_PLAN } from '../config/pricing';

import {
  Gift,
  InfinityIcon,
  MonitorSmartphone,
  ShieldCheck,
  CreditCard,
  Trophy,
} from "lucide-react";

import apple from '../assets/logo/Apple_Pay.png';
import discover from '../assets/logo/Discover.png';
import cb from '../assets/logo/GIE_CB.png';
import Google from '../assets/logo/Google_Pay.png';
import mastercard from '../assets/logo/Mastercard.png';
import visa from '../assets/logo/Visa.png';

export default function Pricing() {
    const contactInfo = CONTACT_CONFIG;
    const [isStandard, setIsStandard] = useState(true);

    const createCheckoutUrl = (plan, redirectUrl) => {
        return `/checkout?plan=${plan}&redirect=${encodeURIComponent(redirectUrl)}`;
    };

    const currentPlans = isStandard ? STANDARD_PLANS : MULTI_SCREEN_PLANS;



    return (
        <>
            <section className="section2 relative overflow-hidden sm:py-12" id="pricing">
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-20">
                    <div className="h-64 w-full" style={{
                        backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>
                <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative z-10">
                    {/* IBO Pro Player Banner */}
                    <div className="bg-gradient-to-r from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] rounded-2xl p-6 mb-8 relative overflow-hidden">
                        {/* Background Pattern */}
                        <div className="absolute inset-0 opacity-10">
                            <div className="absolute inset-0" style={{
                                backgroundImage: `radial-gradient(circle at 25% 25%, #3b82f6 0%, transparent 50%), 
                                                radial-gradient(circle at 75% 75%, #1d4ed8 0%, transparent 50%)`
                            }}>
                            </div>
                        </div>
                        
                        <div className="relative z-10 flex items-center justify-center gap-4">
                            {/* Left Gift Icon */}
                            <div className="flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M20 13v5a3 3 0 0 1-3 3h-4v-8zm-9 0v8H7a3 3 0 0 1-3-3v-5zM9 2a4 4 0 0 1 3 1.354A4 4 0 0 1 15 2h.5A1.5 1.5 0 0 1 17 3.5V4c0 .729-.195 1.412-.535 2H19a2 2 0 0 1 2 2v2c0 .364-.097.706-.268 1H13V8a1 1 0 1 0-2 0v3H3.268A2 2 0 0 1 3 10V8a2 2 0 0 1 2-2h2.535A4 4 0 0 1 7 4v-.5A1.5 1.5 0 0 1 8.5 2Zm0 2a2 2 0 0 0 2 2a2 2 0 0 0-2-2m6 0a2 2 0 0 0-2 2a2 2 0 0 0 2-2"></path>
                                </svg>
                            </div>
                            
                            {/* Main Text */}
                            <div className="text-center">
                                <h2 className="text-xl sm:text-2xl font-bold text-white mb-1">
                                    Gratis App
                                </h2>
                                <p className="text-lg sm:text-xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
                                    Activering voor de IBO Pro Player
                                </p>
                            </div>
                            
                            {/* Right Gift Icon */}
                            <div className="flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 32 32">
                                    <g fill="none">
                                        <path fill="#fcd53f" d="M24.888 30H7.112A2.093 2.093 0 0 1 5 27.914V15l10.877-3.06L27 15v12.914C27 29.06 26.06 30 24.888 30"></path>
                                        <path fill="#f8312f" d="M27 5.847c0-3.384-4.045-5.106-6.466-2.763L16 7.479l-4.533-4.395C9.045.73 5 2.463 5 5.847C5 7.04 5.957 8 7.142 8L16 10.17L24.858 8A2.157 2.157 0 0 0 27 5.847"></path>
                                        <path fill="#ffb02e" d="M27.662 8H4.337C3.6 8 3 8.6 3 9.342v4.316C3 14.4 3.6 15 4.338 15h23.324C28.4 15 29 14.4 29 13.658V9.342C29 8.6 28.4 8 27.662 8"></path>
                                        <path fill="#ca0b4a" d="M16.005 3C14.345 3 13 4.37 13 6.06V30h6V6.06C19.01 4.37 17.666 3 16.005 3"></path>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mb-8">
                        <h1 className="text-2xl md:text-3xl lg:text-4xl mx-auto font-extrabold text-blue-900 mb-4 max-w-3xl leading-snug text-center">
                            Ontdek Onze Beste Abonnementen
                        </h1>
                        <p className="text-sm text-gray-600 max-w-2xl mx-auto leading-relaxed mb-8">
                            Kies het perfecte abonnement voor jouw entertainment
                        </p>

                        {/* Pricing mode toggle */}
                        <div className="inline-flex p-1 bg-gradient-to-r from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] text-white rounded-xl shadow-inner">
                            <button
                                type="button"
                                onClick={() => setIsStandard(true)}
                                className={`px-5 sm:px-8 py-3 rounded-lg font-semibold text-sm sm:text-base transition-all duration-300 ${
                                    isStandard
                                        ? 'bg-white text-[#0a1a5f] shadow-md'
                                        : 'text-white hover:text-yellow-400'
                                }`}
                            >
                                Standaard
                            </button>
                            <button
                                type="button"
                                onClick={() => setIsStandard(false)}
                                className={`px-5 sm:px-8 py-3 rounded-lg font-semibold text-sm sm:text-base transition-all duration-300 ${
                                    !isStandard
                                        ? 'bg-white text-[#0a1a5f] shadow-md'
                                        : 'text-white hover:text-yellow-400'
                                }`}
                            >
                                Multi-Scherm
                            </button>
                        </div>
                    </div>


                    <div
                        key={isStandard ? 'standard' : 'multi'}
                        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pb-5 pricing-cards-animate"
                    >
                        {currentPlans.map((plan) => (
                            <PricingCard
                                key={plan.id}
                                plan={plan}
                                createCheckoutUrl={createCheckoutUrl}
                                planId={plan.id}
                            />
                        ))}
                    </div>
                    {/* LIFETIME PLAN - Centered below the three plans */}
                    <div className="flex justify-center pb-5 mt-6">
                        <div className="w-full max-w-sm service-card bg-gradient-to-br from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] rounded-2xl shadow-lg p-6 h-full border border-gray-100 hover:shadow-3xl transition-all duration-300 relative overflow-hidden transform hover:-translate-y-1 hover:border hover:border-gray-200 pricing-card-gold">
                            <div className="absolute top-10 right-[-40px] rotate-45 z-10">
                                <div className="bg-gradient-to-r from-yellow-400 to-orange-400 text-[#002f9c] text-xs font-bold uppercase tracking-wide px-14 py-1 shadow-sm">
                                    {LIFETIME_PLAN.badge}
                                </div>
                            </div>

                            {/* Icon circulaire en haut */}
                            <div className="flex justify-center mb-4 relative z-10">
                                <div className="w-16 h-16 rounded-full border-2 border-white/30 bg-white/10 flex items-center justify-center">
                                    <InfinityIcon className="w-8 h-8 text-white" />
                                </div>
                            </div>

                            <div className="text-center mb-6 relative z-10">
                                <h3 className="text-2xl font-bold text-[#FAFAFA] mb-2 uppercase">{LIFETIME_PLAN.title}</h3>
                                <div className="text-xl mt-4 text-gray-200">
                                    <span className="line-through">{LIFETIME_PLAN.originalPrice}</span>
                                </div>
                                <div className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400 mb-1">{LIFETIME_PLAN.price}</div>
                                <div className="flex items-center justify-center gap-2 mb-3 flex-wrap">
                                    <span className="text-sm text-[#E8E8E8]">/ {LIFETIME_PLAN.period}</span>
                                    <span className="inline-flex items-center gap-1 px-2.5 py-0.5 text-[11px] font-bold uppercase rounded-full bg-gradient-to-r from-yellow-400 to-orange-400 text-blue-900 shadow-sm">
                                        <Trophy size={11} className="stroke-[2.5]" />
                                        -36% SEIZOENSAANBIEDING 2026/27
                                    </span>
                                </div>
                            </div>

                            <div className="space-y-3 mb-6">
                                {/* Eredivisie, UCL & F1 Seizoen */}
                                <div className="flex items-start gap-3">
                                    <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center mt-0.5">
                                        <Trophy className="w-5 h-5 text-yellow-400 flex-shrink-0" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden />
                                    </div>
                                    <span className="text-sm text-[#E8E8E8] leading-relaxed">
                                        <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
                                            Eredivisie, UCL & F1 Seizoen 2026/27
                                        </span>
                                        {" — Alle wedstrijden in HD/4K zonder onderbrekingen"}
                                    </span>
                                </div>

                                {/* Eenmalige betaling */}
                                <div className="flex items-start gap-3">
                                    <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center mt-0.5">
                                        <CreditCard className="w-5 h-5 text-yellow-400 flex-shrink-0" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden />
                                    </div>
                                    <span className="text-sm text-[#E8E8E8] leading-relaxed">Eenmalige betaling (Geen abonnement)</span>
                                </div>

                                {/* 2 Gelijktijdige schermen */}
                                <div className="flex items-start gap-3">
                                    <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center mt-0.5">
                                        <MonitorSmartphone className="w-5 h-5 text-yellow-400 flex-shrink-0" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden />
                                    </div>
                                    <span className="text-sm text-[#E8E8E8] leading-relaxed">2 Gelijktijdige schermen</span>
                                </div>

                                {/* Acceso completo al Plan PREMIUM */}
                                <div className="flex items-start gap-3">
                                    <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center mt-0.5">
                                        <Gift className="w-5 h-5 text-yellow-400 flex-shrink-0" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden />
                                    </div>
                                    <span className="text-sm text-[#E8E8E8] leading-relaxed">Volledige toegang tot het PREMIUM Pakket</span>
                                </div>

                                {/* 30 Dagen Geld-Terug-Garantie */}
                                <div className="flex items-start gap-3">
                                    <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center mt-0.5">
                                        <ShieldCheck className="w-5 h-5 text-yellow-400 flex-shrink-0" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden />
                                    </div>
                                    <span className="text-sm text-[#E8E8E8] leading-relaxed">30 Dagen Geld-Terug-Garantie</span>
                                </div>
                            </div>

                            <button onClick={() =>
                                    window.open(
                                        createCheckoutUrl('lifetime', LIFETIME_PLAN.link),
                                        "_blank"
                                    )
                                } className="w-full bg-white hover:bg-gray-100 text-gray-900 py-3 rounded-xl font-bold text-sm sm:text-base transition-all duration-300 flex items-center justify-center space-x-2 shadow-xl hover:shadow-2xl transform hover:scale-105">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"/>
                                </svg>
                                <span>NU BESTELLEN</span>
                            </button>
                            {/* 100% Veilig Betalen */}
                            <div className="text-center mb-3 mt-6">
                                <div className="flex items-center justify-center gap-2 text-white text-xs">
                                    <ShieldCheck className="w-4 h-4 text-yellow-400 flex-shrink-0" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden />
                                    <span>100% Veilig Betalen</span>
                                </div>
                            </div>

                            {/* Paiement Sécurisé Garanti */}
                            <div className="mt-4">
                                <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-3 mt-4 p-3 bg-white rounded-xl w-full">
                                    <img src={Google} alt="Google Pay" className="footer-logo w-10 h-auto drop-shadow-md drop-shadow-white" />
                                    <img src={cb} alt="CB" className="footer-logo w-10 h-auto drop-shadow-md drop-shadow-white" />
                                    <img src={visa} alt="Visa" className="footer-logo w-10 h-auto drop-shadow-md drop-shadow-white" />
                                    <img src={apple} alt="Apple Pay" className="footer-logo w-10 h-auto drop-shadow-md drop-shadow-white" />
                                    <img src={discover} alt="Discover" className="footer-logo w-10 h-auto drop-shadow-md drop-shadow-white" />
                                    <img src={mastercard} alt="Mastercard" className="footer-logo w-10 h-auto drop-shadow-md drop-shadow-white" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Simple Contact Banner */}
                    <div className="bg-gradient-to-r from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] rounded-xl p-6 mb-8 text-center">
                        <h3 className="text-xl font-bold text-white mb-2">
                            Heb je een aangepast abonnement nodig?
                        </h3>
                        <p className="text-white/90 mb-4">
                            Neem contact met ons op en wij maken de perfecte oplossing voor jou
                        </p>
                        <a href={contactInfo.whatsappUrl} target="_blank" rel="noopener noreferrer" className="bg-white text-[#0a1a5f] px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
                            Neem contact op
                        </a>
                    </div>
                </div>
            </section>
        </>
    )
}